//WE.Flow.Html.Contracts.Manifests.WebModuleManifest
import { ScriptPathConfig } from "./ScriptPathConfig";
import { ComponentManifest } from "./ComponentManifest";
import { WorkingContextManifest } from "./WorkingContextManifest";
import { MenuManifest } from "./MenuManifest";
import { DialogManifest } from "./DialogManifest";
import { ExternalComponentManifest } from "./ExternalComponentManifest";
import { SideTabManifest } from "./SideTabManifest";
import { ModuleRole } from "./ModuleRole";
import { TestSuiteManifest } from "./TestSuiteManifest";
import { TestManifest } from "./TestManifest";
import { CommandManifest } from "./CommandManifest";
import { UserContextTabManifest } from "./UserContextTabManifest";
import { ImpersonatedUser } from "./ImpersonatedUser";
import { LicenseBundle } from "./LicenseBundle";

export class WebModuleManifest {
    metaConfigs: any[] = null;
    scriptPathConfigs: ScriptPathConfig[] = null;
    componentManifests: ComponentManifest[] = null;
    contextManifests: WorkingContextManifest[] = null;
    menuManifests: MenuManifest[] = null;
    dialogManifests: DialogManifest[] = null;
    externalComponentManifests: ExternalComponentManifest[] = null;
    sideTabManifest: SideTabManifest[] = null;
    moduleRoles: ModuleRole[] = null;
    testSuites: TestSuiteManifest[] = null;
    tests: TestManifest[] = null;
    commandScripts: CommandManifest[] = null;
    userContextTabManifests: UserContextTabManifest[] = null;
    impersonatedUser: ImpersonatedUser = null;
    licenseBundles: LicenseBundle[] = null;
    allowResizeComponents: boolean = false;
    isRoleSelectionExclusive: boolean = false;
    showMenuDetails: boolean = false;
    authorizationManager: string = "";
    cssUrls: string[] = null;
    scriptBundle: string = "";
    isTeamContextOption: boolean = false;
    cacheBuster: string = "";
    moduleDescription: string = "";
    loadEvenIfEmpty: boolean = false;
    inactiveReason: string = "";
}
